import React from 'react';

import { HomePage, NoAuthPage, CookiePolicyPage } from 'app/components/pages';

export const routes = [
    {
        pattern: '/cookie-policy',
        render: ( props ) => <CookiePolicyPage { ...props }/>,
        requireAuthentication: false,
        title: 'Cookie Policy',
        hideCookieAlert: true,
    }, {
        pattern: '/:token',
        render: ( props ) => <HomePage { ...props } />,
        requireAuthentication: true,
        title: 'Hoya Learning Center',
        hideCookieAlert: false,
    }, {
        pattern: '/',
        render: ( props ) => <NoAuthPage { ...props }/>,
        requireAuthentication: false,
        title: 'Welcome',
        hideCookieAlert: false,
    }, 
];
